import { useCallback, useEffect, useState } from 'react';
import { NavigationAndActionClose } from '../icons';
import { theme as appTheme } from '../theme';
import { ToggleButton } from '../toggleButton';
import { PopoutTheme } from './PopoutTheme';
import {
  StyledBackdropTransitions,
  StyledCloseButtonContainer,
  StyledComponentSwitchTransitions,
  StyledPopoutBackdrop,
  StyledPopoutContainer,
  StyledPopoutContainerTransitions,
} from './styled';
import {useTheme} from "styled-components";

export interface PopoutProps {
  visible?: boolean;
  onClose?: () => void;
  theme?: PopoutTheme;
  transitioning?: boolean;
}

export const PopoutTransitionTimeout = 300;

export const Popout: React.FC<PopoutProps> = ({
  visible,
  onClose,
  theme,
  transitioning,
  children,
}) => {
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [visible]);

  const [closeButtonColor, setCloseButtonColor] = useState<string>();

  useEffect(() => {
    switch (theme) {
      case PopoutTheme.Dark:
        setCloseButtonColor(appTheme.colors.primaryK3);
        break;
      case PopoutTheme.Teal:
        setCloseButtonColor(appTheme.colors.primaryW);
        break;
      default:
        setCloseButtonColor(undefined);
    }
  }, [theme]);

  const keyDownHandler = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose && onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    window.addEventListener('keydown', keyDownHandler);
    return () => window.removeEventListener('keydown', keyDownHandler);
  }, [keyDownHandler]);

  const activeTheme = useTheme() as any;

  return (
    <div className="full-width-container">
      <StyledBackdropTransitions
        timeout={500}
        classNames="popout-backdrop"
        in={visible}
        unmountOnExit>
        <StyledPopoutBackdrop />
      </StyledBackdropTransitions>
      <StyledPopoutContainerTransitions
        timeout={500}
        classNames="popout-container"
        in={visible}
        unmountOnExit>
        <StyledPopoutContainer theme={theme} activeTheme={activeTheme}>
          <StyledCloseButtonContainer>
            <ToggleButton
              onClick={onClose}
              icon={<NavigationAndActionClose />}
              color={closeButtonColor}
            />
          </StyledCloseButtonContainer>
          <div>
            <StyledComponentSwitchTransitions
              timeout={PopoutTransitionTimeout}
              classNames="component-switch"
              in={!transitioning}
              out={transitioning}
              unmountOnExit>
              {children}
            </StyledComponentSwitchTransitions>
          </div>
        </StyledPopoutContainer>
      </StyledPopoutContainerTransitions>
    </div>
  );
};
